import { ExpressionValue } from "../../ExpressionValue";
import { BaseStringExpression } from "./BaseString";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringListGetStringByIndexExpression extends BaseStringExpression {
    readonly __type: string = "String List Get String By Index";
    readonly __ruleName: string = "By Index";
    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();
        let dd = new StringDataDefinition();
        dd.list = true;

        this.value1 = ExpressionValue.createExpressionValue(this, "value1", new NumberDataDefinition());
        this.value2 = ExpressionValue.createExpressionValue(this, "value2", dd);
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        let value2 = this.value2.evaluate(data, testContext);
        let value1 = this.value1.evaluate(data, testContext);
        if (value1 < 0) {
            throw new Error("index can not be negative.");
        }
        return value2[value1];
    }
}
